// extracted by mini-css-extract-plugin
export default {"questionSet":"QuestionViewTab__questionSet___QgCga fonts__whitney-book___cSNvy"};